import { signalStoreFeature, withComputed } from '@ngrx/signals';
import { IBusinessUnitStore } from './businessunit.public';

export function withBusinessUnits(businessUnitStore: IBusinessUnitStore) {
    return signalStoreFeature(
        withComputed(() => ({
            businessUnits: businessUnitStore.businessUnits,
        })),
    );
}
